import DepsService from 'services/dependencies';

const CONTEXT = 'app';

export const fetchPrivacyPolicy = async () => {
  const url = DepsService.rest.cms['privacy-policy'].first.url;
  const queryParams = { locale: '*' };
  const urlParams = {};
  return DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/resources/privacy-policy.api.js